var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg calendar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,4h-3V0.7c0-0.4-0.3-0.7-0.7-0.7c0,0,0,0,0,0h-2.5C20.3,0,20,0.3,20,0.7c0,0,0,0,0,0V4h-8V0.7C12,0.3,11.7,0,11.3,0 c0,0,0,0,0,0H8.8C8.4,0,8.1,0.3,8.1,0.7c0,0,0,0,0,0V4h-3c-1.7,0-3,1.3-3,3v22c0,1.7,1.3,3,3,3l0,0h21.8c1.7,0,3-1.3,3-3l0,0V7 C29.9,5.3,28.6,4,26.9,4z M26.5,29h-21c-0.2,0-0.4-0.2-0.4-0.4V10h21.8v18.6C26.9,28.8,26.7,29,26.5,29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b0f7ad074a6517cc012e281e30099d32.svg";
export { ForwardRef as ReactComponent };